import { useQnaEntrypoint } from '@ms/yammer-teams-qna';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

export const useIsTeamsQnaInOneEventsLandingPage = (): boolean => {
  const isExperimentEnabled = useExperimentTreatmentWithoutReporting('TeamsQnAInOneEventsLandingPage') === true;
  const isVirtualEventEntrypoint = useQnaEntrypoint() === 'virtual-event';

  return isExperimentEnabled && isVirtualEventEntrypoint;
};
